// Stepper.js
import React from "react";
import "./styles.scss"; // Assuming styles are in the same folder
import inprogressStepper from "../../Assets/Icons/InprogressStepper.svg";
import progressStepper from "../../Assets/Icons/progressStepper.svg";
import completedStepper from "../../Assets/Icons/completedStepper.svg";

const ProgressStep = ({ steps, currentStep }) => {
  const getStepperIcon = (index) => {
    if (index < currentStep) return completedStepper;
    if (index === currentStep) return inprogressStepper;
    return progressStepper;
  };

  const getStepperLineClass = (index) => {
    return index < currentStep
      ? "stepper-line-active"
      : "stepper-line-inactive";
  };

  return (
    <div className="stepperWrapperBg">
      {steps.map((step, index) => (
        <div key={index} className="step">
          <div className="step-content">
            <img
              className="stepper-icon"
              src={getStepperIcon(index)}
              alt={step.title}
            />
            <div className="step-label">{step.title}</div>
          </div>

          {index < steps.length - 1 && (
            <div className={getStepperLineClass(index)}></div>
          )}
        </div>
      ))}
    </div>
  );
};

export default ProgressStep;
